import { Box, Grid, GridItem, Text, } from '@chakra-ui/react'
import MyDiv from './regularisationCalendar.style'
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

// props pass for highlight date 
interface props {
    attendanceData: AttendanceSummary | null;
    selectedDate: Date;
    highlightDate?: Date | null;
}

interface props {
    attendanceData: AttendanceSummary | null;
    selectedDate: Date;
}

interface AttendanceRecord {
    id: number;
    employeeId: number;
    startTime: string;
    endTime: string | null;
    status: number;
    actualHours: number;
}

interface AttendanceSummary {
    averageHoursPerDay: number;
    leaveOrOtherPercent: number;
    presencePercent: number;
    records: AttendanceRecord[];
}


const RegularisationCalendar = ({ attendanceData, selectedDate, highlightDate }: props) => {

    const getLocalISODate = (date: string | Date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };




    const getStatusColor = (status: number) => {
        switch (status) {
            case 1:
                return 'status_badge green';
            case 0:
                return 'status_badge red';
            case 2:
                return 'status_badge orange';
            case 3:
                return 'status_badge yellow';
            case 4:
                return 'status_badge purple';
            case 5:
                return 'status_badge blue';
            case 6:
                return 'status_badge pink';
            case 7:
                return 'status_badge cyan';
            default:
                return 'status_badge gray';
        }
    };
    const getStatusClass = (status: number) => {
        switch (status) {
            case 0:
                return "Absent";
            case 1:
                return "On Time";
            case 2:
                return "Half Day";
            case 3:
                return "Late";
            case 4:
                return "Early Out";
            case 5:
                return "Punch In Missing";
            case 6:
                return "Punch Out Missing";
            case 7:
                return "Week Off";
            default:
                return "Other";
        }
    };
    return (
        <MyDiv>
            <Box>
                <Grid className='grid_container' mt={2} columnGap={4}>
                    <GridItem colSpan={6} >
                        <Box className="overview_card green">
                            <Text className="font-poppins font_dark text_medium text_sm">Presence</Text>
                            <Text className="font-poppins text_medium text_3xl" color="#008000"> {attendanceData ? `${attendanceData.presencePercent}%` : "0%"}</Text>
                        </Box>
                    </GridItem>
                    <GridItem colSpan={6} >
                        <Box className="overview_card orange">
                            <Text className="font-poppins font_dark text_medium text_sm">Leave & Other</Text>
                            <Text className="font-poppins text_medium text_3xl" color="#FFA500">{attendanceData ? `${attendanceData.leaveOrOtherPercent}%` : "0%"}</Text>
                        </Box>
                    </GridItem>
                </Grid>
                <Grid className='grid_container'>
                    <GridItem colSpan={12}>
                        <FullCalendar
                            key={selectedDate?.toString()}
                            initialDate={selectedDate || new Date()}
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView='dayGridMonth'
                            fixedWeekCount={false}
                            headerToolbar={{
                                left: '',
                                center: '',
                                right: ''
                            }}
                            dayCellDidMount={(info) => {
                                const day = info.date.getDay();
                                if (day === 0 || day === 6) {
                                    info.el.style.backgroundColor = '#F5F5F5';
                                }
                             // light amber highlight for  highlight date
                                if (highlightDate && getLocalISODate(info.date) === getLocalISODate(highlightDate)) {
                                    info.el.style.backgroundColor = '#FFF3CD';   
                                    info.el.style.border = '2px solid #FFA500';
                                    info.el.style.borderRadius = '6px';
                                }
                            }}

                            dayCellContent={({ date }) => {
                                const entry = attendanceData?.records.find(
                                    (r) => getLocalISODate(r.startTime) === getLocalISODate(date)
                                );

                                return (
                                    <Box className="fc-day-content" py={10}>
                                        <Box>{date.getDate()}</Box>
                                        {entry && (
                                            <Box className={getStatusColor(entry.status)} mt={2}>
                                                {getStatusClass(entry.status)}
                                            </Box>
                                        )}
                                    </Box>
                                );
                            }}

                        />
                    </GridItem>
                </Grid>
            </Box>
        </MyDiv>
    )
}

export default RegularisationCalendar
